"use strict";

/* eslint-disable react/jsx-handler-names, react/jsx-no-bind */
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _colr = _interopRequireDefault(require("./vendor/colr"));

var _UIInputStaticLabel = _interopRequireDefault(require("UIComponents/input/UIInputStaticLabel"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UINumberInput = _interopRequireDefault(require("UIComponents/input/UINumberInput"));

var _UIFieldset = _interopRequireDefault(require("UIComponents/form/UIFieldset"));

var modesMap = ['RGB', 'HSB', 'HSL'];

var Params =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Params, _React$Component);

  function Params(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Params);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Params).call(this, props));
    _this.state = {
      inputValue: props.hex.replace('#', '')
    };
    var events = ['onHexHandler', 'onAlphaHandler', 'onColorChannelChange', 'onModeChange', 'getChannelInRange', 'getColorByChannel'];
    events.forEach(function (e) {
      if (_this[e]) {
        _this[e] = _this[e].bind((0, _assertThisInitialized2.default)(_this));
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Params, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.hex !== nextProps.hex) {
        this.setState({
          inputValue: nextProps.hex.replace('#', '')
        });
      }
    }
  }, {
    key: "onHexHandler",
    value: function onHexHandler(evt) {
      var inputValue = evt.target.value.replace(/[^0-9a-f]/gi, '').slice(0, 6);
      this.setState({
        inputValue: inputValue
      });
      if (inputValue.length < 6) return;

      try {
        var color = _colr.default.fromHex(inputValue);

        this.props.onChange({
          hex: color.toHex()
        });
      } catch (e) {
        /* eslint no-empty:0 */
      }
    }
  }, {
    key: "onAlphaHandler",
    value: function onAlphaHandler(event) {
      var alpha = parseInt(event.target.value, 10);

      if (isNaN(alpha)) {
        alpha = 0;
      }

      alpha = Math.max(0, alpha);
      alpha = Math.min(alpha, 100);
      this.props.onChange({
        alpha: alpha
      });
    }
  }, {
    key: "onColorChannelChange",
    value: function onColorChannelChange(index, event) {
      var value = this.getChannelInRange(event.target.value, index);
      var colorChannel = this.getColorChannel();
      colorChannel[index] = value;

      var _this$getColorByChann = this.getColorByChannel(colorChannel),
          hex = _this$getColorByChann.hex,
          hue = _this$getColorByChann.hue;

      this.props.onChange({
        hex: hex,
        hue: hue
      });
    }
  }, {
    key: "getChannelInRange",
    value: function getChannelInRange(value, index) {
      var channelMap = {
        RGB: [[0, 255], [0, 255], [0, 255]],
        HSB: [[0, 360], [0, 100], [0, 100]],
        HSL: [[0, 360], [0, 100], [0, 100]]
      };
      var mode = this.props.mode;
      var range = channelMap[mode][index];
      var result = parseInt(value, 10);

      if (isNaN(result)) {
        result = 0;
      }

      result = Math.max(range[0], result);
      result = Math.min(result, range[1]);
      return result;
    }
  }, {
    key: "getColorByChannel",
    value: function getColorByChannel(colorChannel) {
      var mode = this.props.mode;
      var hex;
      var hue;

      switch (mode) {
        case 'RGB':
          hex = _colr.default.fromRgbArray(colorChannel).toHex();
          break;

        case 'HSB':
          hex = _colr.default.fromHsvArray(colorChannel).toHex();
          hue = colorChannel[0];
          break;

        case 'HSL':
          hex = _colr.default.fromHslArray(colorChannel).toHex();
          hue = colorChannel[0];
          break;

        default:
          hex = _colr.default.fromRgbArray(colorChannel).toHex();
      }

      return {
        hex: hex,
        hue: hue
      };
    }
  }, {
    key: "getColorChannel",
    value: function getColorChannel() {
      var _this$props = this.props,
          hex = _this$props.hex,
          hue = _this$props.hue,
          mode = _this$props.mode;

      var color = _colr.default.fromHex(hex);

      var result;

      switch (mode) {
        case 'RGB':
          result = color.toRgbArray();
          break;

        case 'HSB':
          result = [hue].concat((0, _toConsumableArray2.default)(color.toHsvArray().slice(1)));
          break;

        case 'HSL':
          result = [hue].concat((0, _toConsumableArray2.default)(color.toHslArray().slice(1)));
          break;

        default:
          result = color.toRgbArray();
      }

      return result;
    }
  }, {
    key: "renderRgbaInput",
    value: function renderRgbaInput(colorChannelIndex) {
      var colorChannel = this.getColorChannel();
      var keyName = this.props.mode[colorChannelIndex];
      return _react.default.createElement(_UIInputStaticLabel.default, {
        key: keyName,
        text: keyName,
        className: "private-react-colorpicker--param-input",
        labelWrapperClassName: "private-react-colorpicker--param-input-label-wrapper"
      }, _react.default.createElement(_UINumberInput.default, {
        maxLength: "A",
        value: colorChannel[colorChannelIndex],
        onChange: this.onColorChannelChange.bind(null, colorChannelIndex)
      }));
    }
  }, {
    key: "renderAlphaInput",
    value: function renderAlphaInput() {
      return _react.default.createElement(_UIInputStaticLabel.default, {
        key: "A",
        text: "A",
        className: "private-react-colorpicker--param-input",
        labelWrapperClassName: "private-react-colorpicker--param-input-label-wrapper"
      }, _react.default.createElement(_UINumberInput.default, {
        value: this.props.alpha,
        onChange: this.onAlphaHandler
      }));
    }
  }, {
    key: "renderRgba",
    value: function renderRgba() {
      var _this$props2 = this.props,
          hexOnly = _this$props2.hexOnly,
          includeAlpha = _this$props2.includeAlpha;
      var inputs = [];

      if (!hexOnly) {
        inputs = inputs.concat([this.renderRgbaInput(0), this.renderRgbaInput(1), this.renderRgbaInput(2)]);
      }

      if (includeAlpha) inputs.push(this.renderAlphaInput());
      return inputs;
    }
  }, {
    key: "render",
    value: function render() {
      var fieldsetSize = this.props.fieldsetSize;
      return _react.default.createElement("div", {
        className: "private-react-colorpicker--params"
      }, _react.default.createElement(_UIFieldset.default, {
        _size: fieldsetSize
      }, this.renderRgba(), _react.default.createElement(_UIInputStaticLabel.default, {
        text: "#",
        className: "private-react-colorpicker--param-input",
        labelWrapperClassName: "private-react-colorpicker--param-input-label-wrapper"
      }, _react.default.createElement(_UITextInput.default, {
        maxLength: "7",
        onChange: this.onHexHandler,
        value: this.state.inputValue
      }))));
    }
  }]);
  return Params;
}(_react.default.Component);

exports.default = Params;
Params.propTypes = {
  onChange: _react.PropTypes.func,
  alpha: _react.PropTypes.number,
  fieldsetSize: _UIFieldset.default.propTypes._size,
  hex: _react.PropTypes.string.isRequired,
  hue: _react.PropTypes.number.isRequired,
  hexOnly: _react.PropTypes.bool,
  includeAlpha: _react.PropTypes.bool,
  mode: _react.PropTypes.oneOf(modesMap)
};
Params.defaultProps = {
  mode: modesMap[0]
};
module.exports = exports.default;